export const sources = {
  NPS: {
    url: 'https://www.nps.gov/articles/000/what-might-you-find-in-the-revolutionary-war-pension-files.htm',
    name: 'NPS, "What Might You Find in the Revolutionary War Pension Files"',
    simpleName: 'NPS',
  },
  M804: {
    url: 'https://www.archives.gov/files/research/microfilm/m804.pdf',
    name: 'National Archives Microfilm Publication M804',
    simpleName: 'M804 publication',
  },
  Data: {
    url: 'https://huggingface.co/datasets/RevolutionCrossroads/nara_revolutionary_war_pension_files',
    name: 'Data',
    simpleName: 'Data',
  },
};
